export default __webpack_public_path__ + "static/media/logo.77e152ab.png";